import React from 'react';
import '../css/callout.css';

const ICONS = {
    info: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
        </svg>
    ),
    warning: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
        </svg>
    ),
    security: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
    ),
};

const TITLES = {
    info: 'Note',
    warning: 'Heads up',
    security: 'Security',
};

const Callout = ({ type = 'info', title, children }) => {
    const variant = ICONS[type] ? type : 'info';
    const headerText = title || TITLES[variant];
    return (
        <aside className={`callout callout-${variant}`} role="note">
            {headerText && (
                <div className="callout-header">
                    <span className="callout-icon" aria-hidden="true">{ICONS[variant]}</span>
                    <strong className="callout-title">{headerText}</strong>
                </div>
            )}
            <div className="callout-content">{children}</div>
        </aside>
    );
};

export default Callout;
